import { Routes } from "../../methods/ApiRoutes";

const shared = {
  title: 'Offers',
  addTitle: 'Offer',
  url: 'offer',
  ...Routes.Offer
};

export default shared;
